import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Car } from "lucide-react";

function Row({ s, onSaved }) {
  const [en, setEn] = useState(s.enabled);
  const [lim, setLim] = useState(String(s.monthly_limit));
  const toggle = async (v) => { setEn(v); try { await api.patch(`/admin/shops/${s.shop_id}/plate-lookup`, { enabled: v }); onSaved(); } catch (e) { setEn(!v); toast.error(formatApiError(e)); } };
  const save = async () => { try { await api.patch(`/admin/shops/${s.shop_id}/plate-lookup`, { monthly_limit: Number(lim) }); toast.success("Limite salvo"); onSaved(); } catch (e) { toast.error(formatApiError(e)); } };
  return (
    <tr className="border-t border-zinc-800" data-testid={`plate-row-${s.shop_id}`}>
      <td className="py-2 pr-2 text-zinc-100">{s.name}</td>
      <td><Switch data-testid={`plate-enabled-${s.shop_id}`} checked={en} onCheckedChange={toggle} /></td>
      <td data-testid={`plate-usage-${s.shop_id}`} className="tabular-nums text-zinc-300">{s.used}/{s.monthly_limit}</td>
      <td className="text-right">
        <div className="inline-flex items-center gap-1">
          <Input data-testid={`plate-limit-${s.shop_id}`} type="number" value={lim} onChange={(e) => setLim(e.target.value)} className="h-8 w-20 bg-zinc-900 border-zinc-800 text-right" />
          <Button data-testid={`plate-save-${s.shop_id}`} onClick={save} className="h-8 bg-green-brand hover:bg-green-brandDark text-white text-xs">Salvar</Button>
        </div>
      </td>
    </tr>
  );
}

export function PlateLookupAdmin() {
  const [d, setD] = useState(null);
  const load = () => api.get("/admin/plate-lookup").then(({ data }) => setD(data)).catch(() => setD(null));
  useEffect(() => { load(); }, []);
  if (!d) { return null; }
  return (
    <details data-testid="plate-lookup-admin" className="rounded-2xl border border-card2-border bg-card2 p-4">
      <summary className="cursor-pointer flex flex-wrap items-center gap-2 text-sm font-bold text-zinc-200"><Car className="h-4 w-4 text-sky-300" /> Consulta por placa · {d.month}
        <span data-testid="plate-provider-badge" className={`text-[11px] font-mono-caps px-2 py-0.5 rounded-full ${d.configured ? "bg-green-brand/20 text-green-300" : "bg-amber-500/20 text-amber-300"}`}>{d.configured ? `Provedor: ${d.provider}` : "Provedor não configurado"}</span>
      </summary>
      {!d.configured && <p className="mt-2 text-xs text-amber-300">Defina os Secrets PLATE_API_PROVIDER e PLATE_API_KEY para liberar a consulta externa. Enquanto isso, as oficinas podem estar ligadas, mas verão o aviso "Consulta ainda não configurada".</p>}
      <table className="w-full text-sm mt-3"><thead><tr className="text-[11px] text-zinc-500 text-left"><th className="pr-2">Oficina</th><th>Ligada?</th><th>Uso/limite</th><th className="text-right">Limite mensal</th></tr></thead>
        <tbody>{d.shops.map((s) => <Row key={s.shop_id} s={s} onSaved={load} />)}</tbody></table>
    </details>
  );
}
